import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCabinet: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="cabinet"><path d="M11.25 4H2.75C2.33579 4 2 4.33579 2 4.75V11.25C2 11.6642 2.33579 12 2.75 12H4.15965L3.00956 19.1306C2.9436 19.5395 3.22164 19.9245 3.63057 19.9904C4.03949 20.0564 4.42446 19.7784 4.49042 19.3694L5.67904 12H11.25V4Z" fill="currentColor"/><path d="M19.8403 12H21.25C21.6642 12 22 11.6642 22 11.25V4.75C22 4.33579 21.6642 4 21.25 4H12.75V12H18.321L19.5096 19.3694C19.5755 19.7784 19.9605 20.0564 20.3694 19.9904C20.7784 19.9245 21.0564 19.5395 20.9904 19.1306L19.8403 12Z" fill="currentColor"/></CentralIconBase>;
};

export default IconCabinet;
